module.exports = __webpack_public_path__ + "Bild_1.575e6cfdde4455da9b9c7a8565b2d7cd.png";